// Format number as currency with Philippine Peso symbol
export const formatCurrency = (amount: number, currency = 'PHP'): string => {
  const formatted = new Intl.NumberFormat('en-PH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  
  // Directly prepend peso symbol to avoid font rendering issues
  return `₱${formatted}`;
};

// Format currency for PDF with proper spacing
export const formatCurrencyForPDF = (amount: number): string => {
  const formatted = new Intl.NumberFormat('en-PH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  
  return `₱${formatted}`;
};

// Format number as percentage
export const formatPercentage = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value / 100);
};

// Format PHP currency for display
export const formatPHP = (amount: number): string => {
  return formatCurrency(amount);
};

// Parse currency string to number
export const parseCurrency = (currencyString: string): number => {
  // Remove currency symbol and commas, then parse
  const cleanString = currencyString.replace(/[₱,\s]/g, '');
  return parseFloat(cleanString) || 0;
};

// Format currency without symbol (for calculations)
export const formatNumber = (amount: number): string => {
  return new Intl.NumberFormat('en-PH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
